import styled from 'styled-components'

/**
 * Clamps the wrapped text to `$maxLines` lines, truncating with an ellipsis
 * when content overflows. Pair with the native `title` attribute on the same
 * element to surface the full value as a hover tooltip.
 *
 * Mirrors the pattern used in
 * `components/EditableDataTable/components/APDescriptionCell/styles/LineWrapperStyled`.
 * Worth lifting to a shared util if a third consumer shows up.
 */
export const LineClampStyled = styled.div<{ $maxLines: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ $maxLines }) => $maxLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: break-word;
`
